'use strict';

// Setup zoom result dimension
// resultFactor -> zoom image container dimension factor
// lensFactor -> zoom lens dimension factor
// resultLensFactor -> zoom lens and zoom image container ratio factor
var resultFactor = 1.05;
var lensFactor = 0.2738;
var resultLensFactor = 482;

/**
 *
 * @param {element} imgElement source Image
 * @param {string} resultID result element id
 */
function imageZoom(imgElement, resultID) {
    var img;
    var lens;
    var result;
    var cx;
    var cy;
    var imgWidth;
    var imgHeight;
    /**
     *
     * @param {event} mouseEvent cursor event
     * @returns {Object} cordinate object
     */
    function getCursorPos(mouseEvent) {
        var imageOffset;
        var x = 0;
        var y = 0;
        var event;
        event = mouseEvent || window.event;
        /* get the x and y positions of the image: */
        imageOffset = img.offset();
        /* calculate the cursor's x and y coordinates, relative to the image: */
        x = event.pageX - imageOffset.left;
        y = event.pageY - imageOffset.top;
        /* consider any page scrolling: */
        return { x: x, y: y };
    }
    /**
     *
     * @param {event} mouseEvent document event
     */
    function moveLens(mouseEvent) {
        var position;
        var x;
        var y;
        var parentEle = $('.primary-images .herobanner-top').find('.slick-current');
        var imgZoomLens = parentEle.find('.img-zoom-lens');
        /* prevent any other actions that may occur when moving over the image: */
        mouseEvent.preventDefault();
        /* get the cursor's x and y positions: */
        position = getCursorPos(mouseEvent);
        /* calculate the position of the lens: */
        x = position.x - (imgZoomLens.width() / 2);
        y = position.y - (imgZoomLens.height() / 2);
        /* prevent the lens from being positioned outside the image: */
        if (x > imgWidth - imgZoomLens.width()) { x = imgWidth - imgZoomLens.width(); }
        if (x < 0) { x = 0; }
        if (y > imgHeight - imgZoomLens.height()) { y = imgHeight - imgZoomLens.height(); }
        if (y < 0) { y = 0; }
        /* set the position of the lens: */
        imgZoomLens.css('left', x + 'px');
        imgZoomLens.css('top', y + 'px');
        /* display what the lens "sees": */
        result.css('width', (imgWidth * resultFactor) + 'px');
        result.css('height', (imgHeight * resultFactor) + 'px');
        result.css('background-position', '-' + (x * cx) + 'px -' + (y * cy) + 'px');
    }
    img = imgElement;
    imgWidth = parseFloat(img.css('width').split('px')[0]);
    imgHeight = parseFloat(img.css('height').split('px')[0]);
    result = $('#' + resultID);
    /* create lens: */
    lens = img.parent().find('.img-zoom-lens');
    lens.removeClass('d-none');
    lens.css('width', (imgWidth * lensFactor) + 'px');
    lens.css('height', (imgHeight * lensFactor) + 'px');
    /* insert lens: */
    /* calculate the ratio between result DIV and lens: */
    cx = resultLensFactor / lens.width();
    cy = resultLensFactor / lens.height();
    /* set background properties for the result DIV: */
    result.css('background-image', "url('" + img.attr('hi-res-url') + "')");
    result.css('background-size', (imgWidth * cx) + 'px ' + (imgHeight * cy) + 'px');
    /* execute a function when someone moves the cursor over the image, or the lens: */
    img.closest('.imgid-pdp.zoom-tile').on('mousemove', moveLens);
}

/**
 * Initializes the image zoom functionality for product images on PDP page.
 *
 * The zoom feature is activated for screens wider than or equal to 1024px.
 * When the user hovers over an image, a zoom lens and a zoomed-in view of the image are displayed.
 *
 * Mouseenter event on the image container:
 *  - Displays the zoom result container.
 *  - Activates zoom by calling the imageZoom function.
 *  - Adds an opacity overlay to the image container.
 *
 * Mouseleave event on the image container:
 *  - Hides the zoom result container.
 *  - Hides the zoom lens and resets the image container's style.
 *  - Removes the opacity overlay from the image container.
 *
 * For screens smaller than 1024px, the zoom functionality is disabled.
 */
function initImageZoom() {
    if ($(window).width() >= 1024) {
        $('.primary-images').on('mouseenter', '.herobanner-top .imgid-pdp.zoom-tile', function () {
            var activeImage = $('.herobanner-top').find('.slick-slide.slick-current img');
            if (activeImage.length > 0) {
                $('#hover-result-container').css('display', 'block');
                imageZoom(activeImage, 'hover-result');
                $('.imgid-pdp').addClass('imgid-overopacity');
            }
        });
        $('.primary-images').on('mouseleave', '.herobanner-top .imgid-pdp.zoom-tile', function () {
            $('#hover-result-container').css('display', 'none');
            $('div.img-zoom-lens').addClass('d-none').removeAttr('style');
            $('.imgid-pdp').removeClass('imgid-overopacity');
        });
    } else {
        $('.primary-images').off('mouseenter mouseleave');
        $('#hover-result-container').css('display', 'none');
        $('div.img-zoom-lens').addClass('d-none').removeAttr('style');
        $('.imgid-pdp').removeClass('imgid-overopacity');
    }
}

module.exports = {
    initImageZoom: initImageZoom
};
